import { memo } from "react";
import { createPortal } from "react-dom";
import { useGetFloatingUIPortalElement } from "../../../ui";
import { Notification } from "../Notification";
import { useNotificationMessages } from "../NotificationContext";

import styles from "./style.module.scss";

export const NotificationsContainer = memo(() => {
  const messages = useNotificationMessages();
  const portalElement = useGetFloatingUIPortalElement()

  return portalElement
    ? createPortal(
      <div className={styles.root}>
        {messages.map((props) => <Notification {...props} key={props.messageKey} />)}
      </div>,
      portalElement,
    )
    : null;
});